/*
 * @Author: Zach
 * @Date: 2023-02-09 16:22:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-03-03 11:22:41
 */
import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";
let CountryRestServiceConfig: IRestfulConfigMap = {
    "countryRestService": {
        // TODO base对应接口地址
        appPath: envConfig.appPath("base"),
        isAuth: true,
        actions: {
            // 获取国家列表(/api/countries)
            // 过滤被制裁国家名单(/api/countries/sanction)
            getCountryList: {
                method: "get",
                path: "/api/countries/sanction",
                testPath: "/api/countries/sanction",
                paramDefaults: {
                    page: "@page",
                    limit: "@limit",
                    filter: "@filter",
                    sort: "@sort"
                }
            },
            // 获取区域
            getZoneByCountryId: {
                method: "get",
                path: "/api/countries/:countryId/zones",
                testPath: "/api/countries/:countryId/zones",
                paramDefaults: {
                    countryId: "@countryId"
                }
            },
            //获取可用国际地区数据列表
            getUsableCountries: {
                method: "get",
                path: "/api/countries/available",
                testPath: "/api/countries/available",
                paramDefaults: {
                    page: "@page",
                    limit: "@limit",
                    filter: "@filter",
                    sort: "@sort"
                }
            },
        }
    }
}

export { CountryRestServiceConfig };